export const GTM_ID = {
  CTA_BUTTON_INTERNAL_LINK: 'cta-button-internal-link',
  MAILTO_LINK: 'mailto-link',
  INTERNAL_LINK: 'internal-link',
  EXTERNAL_LINK: 'external-link',
  PLAY_PODCAST: 'play-podcast',
  TRIGGER_ATOM: 'trigger-atom',
  ABOUT_US_CTA: 'about-us-cta',
  CIRCULAR_EXAMPLES_EXPLORE_EXAMPLE: 'circular-examples-explore-example',
  READ_MORE: 'read-more',
  CIRCULAR_EXAMPLE_LINK: 'circular-example-link',
  CIRCULAR_EXAMPLES_TAB: 'circular-examples-tab',
  TILE_BLOCK_CTA: 'tile-block-cta',
  MAIN_FOOTER_LINK: 'main-footer-link',
  SUB_FOOTER_LINK: 'sub-footer-link',
  LEGEND_BLOCK_LINK: 'legend-block-link',
  ACCORDION_ITEM: 'accordion-item',
  DOWNLOAD_LINK: 'download-link',
  FLIP_CARD_LINK: 'flip-card-link',
  CATEGORY_SELECT: 'category-select',
  FILTER_SELECT: 'filter-select',
  DOWNLOAD_ALL_DATA_LINK: 'download-all-data-link',
  BACK_TO_SIGNATORY_REPORT_LINK: 'back-to-signatory-report-link',
  HOMEPAGE_MASTHEAD_CTA: 'homepage-masthead-cta',
  IFRAME_ELEMENT: 'iframe-element',
  LANGUAGE_SELECTOR_CLOSED_VIEW: 'language-selector-closed-view',
  LANGUAGE_BAR_TOGGLE: 'language-bar-toggle',
  LANGUAGE_SELECTOR_OPEN_VIEW: 'language-selector-open-view',
  LANGUAGE_LINK: 'language-link',
  NAV_BAR_HOME_LINK: 'nav-bar-home-link',
  SEARCH_NAV_LINK: 'search-nav-link',
  MAIN_NAV_LINK: 'main-nav-link',
  MAIN_NAV_LINK_LANG: 'main-nav-link-lang',
  FLYOVER_LETTERBOX_LINK: 'flyover-letterbox-link',
  FLYOVER_LINK: 'flyover-link',
  SEARCH_RESULT: 'search-result',
  SIGN_UP_FOOTER_LINK: 'sign-up-footer-link',
  FOLLOW_US_LINK: 'follow-us-link',
  PILLS_SELECTOR: 'pills-selector',
  TABBED_BLOCK_TAB: 'tabbed-block-tab',
  TILE_COLUMN_TILE: 'tile-column-tile',
  TILE_COLUMN_VIEW_ALL: 'tile-column-view-all',
  SECONDARY_NAV_TAB: 'secondary-nav-tab',
  TILE_BLOCK: 'tile-block',
  SEARCH_BAR: 'search-bar',
  LOGO_BLOCK: 'logo-block',
  ABOUT_US_LETTERBOX_LINK: 'about-us-letterbox-link',
  FLYOVER_LINK_FOOTER: 'flyover-link-footer',
  FLYOVER_LINK_COLUMN: 'flyover-link-column',
  CSI_TILE: 'csi-tile',
  CSI_HITS: 'csi-hits',
  CSI_TILE_LINK: 'csi-tile-link',
  CSI_TILE_DISCLAIMER: 'csi-tile-disclaimer',
  CSI_MOBILE_TOGGLE: 'cis-mobile-toggle',
  HONEYCOMB_TAB: 'reel-tab',
  IMAGE_PIN: 'image-pin',
};

export type GTM_ID_KEYS = (typeof GTM_ID)[keyof typeof GTM_ID];
